import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconRegistryService {
  private iconsRegistered = false;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    // Register icons immediately in constructor
    this.registerIcons();
  }

  registerIcons() {
    if (this.iconsRegistered) return;
    try {
      // Common icons
      
      this.matIconRegistry.addSvgIcon(
        'play-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/play.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'dashboard-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/dashboard.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'settings-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/settings.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'variables-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/variable.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'eru-logo',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/eru.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'edit',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/edit.svg')
      );

      this.matIconRegistry.addSvgIcon(
        'delete',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/delete.svg')
      );

      this.matIconRegistry.addSvgIcon(
        'smart_toy',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/smart_toy.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'message-box',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/message_box.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'message-box-accept',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/message_box_accept.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'message-box-reject',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/message_box_reject.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'repository',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/repository.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'import',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/import.svg')
      );

      // Projects icons
      this.matIconRegistry.addSvgIcon(
        'project-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/projects/project.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'user-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/projects/user.svg')
      );

      // EruAuth icons
      this.matIconRegistry.addSvgIcon(
        'authorizer-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/eruauth/authorizer.svg')
      );

      // EruFiles icons
      this.matIconRegistry.addSvgIcon(
        'files_icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/erufiles/files-icon.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'storage-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/eruauth/storage.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'key-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/erufiles/key-icon.svg')
      );
      

      

      // Service icons
      this.matIconRegistry.addSvgIcon(
        'eru-ai',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/services/eru-ai.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'eru-functions',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/services/eru-functions.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'eru-gateway',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/services/eru-gateway.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'eru-ql',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/services/eru-ql.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'eru-auth',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/services/eru-auth.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'eru-files',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/services/eru-files.svg')
      );

      

      // EruGateway icons
      this.matIconRegistry.addSvgIcon(
        'authorizer-list-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/eruauth/authorizer-list-icon.svg')
      );

      // EruQL icons
      this.matIconRegistry.addSvgIcon(
        'ql-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/ql-icon.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'my-query-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/my-query-icon.svg')
      );

      // EruAgent icons
      this.matIconRegistry.addSvgIcon(
        'agent-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/agent.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'tool-icon',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/tool.svg')
      );

      this.matIconRegistry.addSvgIcon(
        'secure',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/secure.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'join',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/join.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'reload',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/reload.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'transform',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/transform.svg')
      );
      this.matIconRegistry.addSvgIcon(
        'untrack',
        this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/common/untrack.svg')
      );

      this.iconsRegistered = true;
      console.log('Icons registered successfully');
    } catch (error) {
      console.error('Error registering icons:', error);
    }
  }
} 